const IconData = {
  'smile-outlined': '☺️',
  'grinning-face': '😀',
  'grinning-face-with-smiling-eyes': '😁',
  'beaming-face-with-smiling-eyes': '😃',
  'grinning-face-with-sweat': '😅',
  'rolling-on-the-floor-laughing': '🤣',
  'face-with-tears-of-joy': '😂',
  'slightly-smiling-face': '😊',
  'upside-down-face': '🙃',
  'winking-face': '😉',
  'heart-eyes': '😍',
  'star-struck': '🤩',
  'money-mouth-face': '🤑',
  sunglasses: '😎',
  'nerd-face': '🤓',
  'face-with-monocle': '🧐',
  'confused-face': '😕',
  'worried-face': '😟',
  'frowning-face': '😦',
  'angry-face': '😠',
  'pouting-face': '😡',
  'crying-face': '😢',
  'loudly-crying-face': '😭',
  'face-with-symbols-on-mouth': '🤬',
  'exploding-head': '🤯',
  'shushing-face': '🤫',
  'sleeping-face': '😴',
  'face-with-head-bandage': '🤕',
  'face-with-thermometer': '🤒',
  'face-with-cold-sweat': '😓',
  'face-screaming-in-fear': '😱',
  'astonished-face': '😲',
  'zipper-mouth-face': '🤐',
  'thinking-face': '🤔',
  'face-with-raised-eyebrow': '🤨',
  'face-with-rolling-eyes': '🙄',
  'hushed-face': '😯',
  'sleepy-face': '😪',
  'dizzy-face': '😵',
  'face-without-mouth': '😶',
  'neutral-face': '😐',
  'expressionless-face': '😑',
  'smirking-face': '😏',
  heart: '❤️',
  'orange-heart': '🧡',

  rocket: '🚀',
  'flying-saucer': '🛸',
  fire: '🔥',
  sparkles: '✨',
  star: '⭐',
  'glowing-star': '🌟',
  'shooting-star': '🌠',
  candy: '🍭',
  balloon: '🎈',
  'confetti-ball': '🎊',
  tada: '🎉',
  'party-popper': '🎉',
  'clapping-hands': '👏',
  'thumbs-up': '👍',
  'thumbs-down': '👎',
  'fist-bump': '👊',
  'ok-hand': '👌',
  'victory-hand': '✌️',
  handshake: '🤝',
  'raising-hands': '🙌',
  pray: '🙏',
  muscle: '💪',
  'check-mark': '✔️',
  'cross-mark': '❌',
  'exclamation-mark': '❗',
  'question-mark': '❓',
  'hundred-points': '💯',
  warning: '⚠️',
  'stop-sign': '🛑',
  'octagonal-sign': '🛑',
  octopus: '🐙',
  alien: '👽',
  robot: '🤖',
  'clown-face': '🤡',
  skull: '💀',
  ghost: '👻',
  zombie: '🧟',
  vampire: '🧛',
  mermaid: '🧜',
  fairy: '🧚',
  unicorn: '🦄',
  dragon: '🐉',
  lion: '🦁',
  tiger: '🐯',
  bear: '🐻',
  panda: '🐼',
  koala: '🐨',
  penguin: '🐧',
  dolphin: '🐬',
  whale: '🐋',
  shark: '🦈',
  briefcase: '💼',
  'office-building': '🏢',
  factory: '🏭',
  'chart-with-upwards-trend': '📈',
  'chart-with-downwards-trend': '📉',
  'bar-chart': '📊',
  'pie-chart': '📈',
  calendar: '📅',
  memo: '📝',
  clipboard: '📋',
  notebook: '📓',
  'notebook-with-decorative-cover': '📔',
  ledger: '📒',
  book: '📚',
  reading: '📖',
  'alarm-clock': '⏰',
  stopwatch: '⏱',
  timer: '⏲',
  hourglass: '⏳',
  'hourglass-flowing-sand': '⏳',
  pen: '✒️',
  'fountain-pen': '🖋',
  paintbrush: '🖌',
  crayon: '🖍',
  highlighter: '🖊',
  'file-folder': '📁',
  'open-file-folder': '📂',
  'file-cabinet': '🗄️',
  'file-box': '🗃️',
  'floppy-disk': '💾',
  cd: '💿',
  dvd: '📀',
  computer: '💻',
  'desktop-computer': '🖥️',
  printer: '🖨️',
  keyboard: '⌨️',
  mouse: '🖱️',
  telephone: '📞',
  'mobile-phone': '📱',
  pager: '📟',
  'fax-machine': '📠',
  battery: '🔋',
  'electric-plug': '🔌',
  'light-bulb': '💡',
  bulb: '💡',
  'spiral-notepad': '🗒️',
  'ring-binder': '📒',
  'bookmark-tabs': '📑',
  pushpin: '📌',
  'round-pushpin': '📍',
  paperclip: '📎',
  'linked-paperclips': '🖇️',
  'card-index': '🗂️',
  'card-index-dividers': '🗃️',
  'file-folder': '📁',
  'man-office-worker': '👨‍💼',
  'woman-office-worker': '👩‍💼',
  'man-technologist': '👨‍💻',
  'woman-technologist': '👩‍💻',
  'man-scientist': '👨‍🔬',
  'woman-scientist': '👩‍🔬',
  'man-student': '👨‍🎓',
  'woman-student': '👩‍🎓',
  'man-teacher': '👨‍🏫',
  'woman-teacher': '👩‍🏫',
  'man-judge': '👨‍⚖️',
  'woman-judge': '👩‍⚖️',
  'man-factory-worker': '👨‍🏭',
  'woman-factory-worker': '👩‍🏭',
  'man-cook': '👨‍🍳',
  'woman-cook': '👩‍🍳',
  'man-mechanic': '👨‍🔧',
  'woman-mechanic': '👩‍🔧',
  'man-construction-worker': '👨‍🏗️',
  'woman-construction-worker': '👩‍🏗️',
  'man-pilot': '👨‍✈️',
  'woman-pilot': '👩‍✈️',
  'man-firefighter': '👨‍🚒',
  'woman-firefighter': '👩‍🚒',
  'man-health-worker': '👨‍⚕️',
  'woman-health-worker': '👩‍⚕️',
  'man-artist': '👨‍🎨',
  'woman-artist': '👩‍🎨',
  'man-musician': '👨‍🎤',
  'woman-musician': '👩‍🎤',
  'man-dancer': '👨‍🕺',
  'woman-dancer': '👩‍🕺',
  'man-singer': '👨‍🎤',
  'woman-singer': '👩‍🎤',
  'man-business-suit-levitating': '🕴️',
  'woman-business-suit-levitating': '🕴️',
  'man-in-manual-wheelchair': '👨‍🦽',
  'woman-in-manual-wheelchair': '👩‍🦽',
  'man-in-mobility-scooter': '👨‍🦼',
  'woman-in-mobility-scooter': '👩‍🦼',
  'man-with-probing-cane': '👨‍🦯',
  'woman-with-probing-cane': '👩‍🦯',
  gear: '⚙️',
  wrench: '🔧',
  hammer: '🔨',
  'nut-and-bolt': '🔩',
  toolbox: '🧰',
  construction: '🚧',
  'magnifying-glass': '🔍',
  laptop: '💻',
  smartphone: '📱',
  tablet: '📲',
  printer: '🖨️',
  'telephone-receiver': '📞',
  fax: '📠',
  email: '📧',
  postbox: '📮',
  mailbox: '📬',
  package: '📦',
  label: '🏷️',
  scales: '⚖️',
  clipboard: '📋',
  stopwatch: '⏱',
  calendar: '📅',
  'bar-chart': '📊',
  'pie-chart': '📈',
  graph: '📉',

  telephone: '☎️',
  'account-book-filled': '📖',
  'alert-filled': '⚠️',
  'alipay-circle-filled': '🅰️',
  'android-filled': '🤖',
  'api-filled': '🔌',
  'apple-filled': '🍏',
  'appstore-filled': '🛒',
  'audio-filled': '🔊',
  'bank-filled': '🏦',
  'bell-filled': '🔔',
  'book-filled': '📚',
  'box-plot-filled': '📦',
  'bug-filled': '🐞',
  'build-filled': '🔧',
  'bulb-filled': '💡',
  'calculator-filled': '🧮',
  'calendar-filled': '📅',
  'camera-filled': '📷',
  'car-filled': '🚗',
  'carry-out-filled': '🛍️',
  'check-circle-filled': '✅',
  'check-square-filled': '☑️',
  'chrome-filled': '🌐',
  'clock-circle-filled': '🕰️',
  'close-square-filled': '❎',
  'cloud-filled': '☁️',
  'code-filled': '💻',
  'code-sandbox-circle-filled': '🔲',
  'compass-filled': '🧭',
  'contacts-filled': '📇',
  'container-filled': '📦',
  'control-filled': '🎛️',
  'copy-filled': '📋',
  'copyright-circle-filled': '©️',
  'credit-card-filled': '💳',
  'crown-filled': '👑',
  'customer-service-filled': '🛎️',
  'dashboard-filled': '📊',
  'database-filled': '💾',
  'dislike-filled': '👎',
  'dollar-circle-filled': '💵',
  'dribbble-circle-filled': '🅾️',
  'dropbox-circle-filled': '📦',
  'environment-filled': '🌍',
  'euro-circle-filled': '💶',
  'experiment-filled': '⚗️',
  'eye-filled': '👁️',
  'facebook-filled': '📘',
  'file-add-filled': '📂',
  'file-excel-filled': '📊',
  'file-exclamation-filled': '❗',
  'file-filled': '📄',
  'file-image-filled': '🖼️',

  'file-zip-filled': '📦',
  'filter-filled': '🔍',
  'fire-filled': '🔥',
  'flag-filled': '🚩',
  'folder-add-filled': '📁',

  'folder-open-filled': '📂',
  'format-painter-filled': '🎨',
  'frown-filled': '🙁',
  'funnel-plot-filled': '🔻',
  'gift-filled': '🎁',
  'github-filled': '🐙',
  'gitlab-filled': '🐙',
  'gold-filled': '🏅',
  'hdd-filled': '💽',
  'home-filled': '🏠',
  'hourglass-filled': '⏳',
  'idcard-filled': '🆔',
  'insurance-filled': '🛡️',
  'interaction-filled': '🔄',
  'layout-filled': '📐',
  'like-filled': '👍',
  'lock-filled': '🔒',
  'mac-command-filled': '⌘️',
  'mail-filled': '📧',
  'medicine-box-filled': '💊',
  'meh-filled': '😐',
  // Added new emojis
  'briefcase-filled': '💼',
  'church-filled': '⛪️',
  'cricket-filled': '🏏',
  'football-filled': '⚽️',
  'golf-filled': '🏌️',
  'mosque-filled': '🕊',
  'church-filled': '⛪️',
  'cricket-filled': '🏏',
  'football-filled': '⚽️',
  'golf-filled': '🏌️',
  'mosque-filled': '🕊',

  // New additions
  'atom-filled': '⚛️',
  'barcode-filled': '📇',
  'bi-filled': '📊',
  'brackets-filled': '〔〕',
  'chart-filled': '📈',
  'clipboard-filled': '📋',
  'cluster-filled': '🗺️',
  'compass-filled': '🧭',
  'cpu-filled': '💻',
  'database-filled': '💾',
  'desktop-filled': '🖥️',
  'dna-filled': '🧬',
  'document-filled': '📄',
  'earth-filled': '🌎',
  'email-filled': '📧',
  'factory-filled': '🏭',
  'file-chart-filled': '📊',
  'file-code-filled': '💻',
  'file-image-filled': '🖼️',
  'file-list-filled': '📝',
  'file-text-filled': '📄',

  'gauge-filled': '📊',
  'gear-filled': '⚙️',
  'grid-filled': '📈',
  'hierarchy-filled': '🗺️',
  'inbox-filled': '📧',
  'industry-filled': '🏭',
  'info-filled': 'ℹ️',
  'lab-filled': '🔬',
  'laptop-filled': '💻',
  'layers-filled': '📈',
  'library-filled': '📚',
  'link-filled': '🔗',
  'list-filled': '📝',
  'location-filled': '📍',
  'map-filled': '🗺️',
  'menu-filled': '📋',
  'microchip-filled': '💻',
  'mobile-filled': '📱',
  'money-filled': '💸',
  'monitor-filled': '🖥️',
  'network-filled': '📁',
  'node-filled': '🗺️',
  'paper-clip-filled': '📋',
  'passport-filled': '🛂️',
  'pencil-filled': '✏️',
  'phone-filled': '📞',
  'picture-filled': '🖼️',
  'pie-chart-filled': '📊',
  'pin-filled': '📍',
  'printer-filled': '🖨️',
  'projector-filled': '📽',
  'pushpin-filled': '📍',
  'qrcode-filled': '📱',
  'radar-filled': '📍',
  'robot-filled': '🤖',
  'rocket-filled': '🚀',
  'rss-filled': '📻',
  'satellite-filled': '🛰️',
  'scale-filled': '⚖️',
  'scanner-filled': '📊',
  'screenshot-filled': '📸',
  'server-filled': '💻',
  'settings-filled': '🔧',
  'shield-filled': '🛡️',
  'sitemap-filled': '🗺️',
  'speech-filled': '💬',
  'speed-filled': '⏱️',
  'star-filled': '⭐️',
  'stats-filled': '📊',
  'stop-filled': '⏹️',
  'stopwatch-filled': '⏱️',
  'tablet-filled': '📱',
  'tag-filled': '📝',
  'target-filled': '🎯',
  'terminal-filled': '💻',
  'test-tube-filled': '🔬',
  'timer-filled': '⏱️',
  'toolbox-filled': '🧮',
  'trophy-filled': '🏆',
  'tv-filled': '📺',
  'umbrella-filled': '⛔️',
  'unlock-filled': '🔓',
  'upload-filled': '⬆️',
};

export default IconData;
